import { BaseContainerModel } from '../../base-container.model';
import {bl_fi_mto_component_tiered_pricing_RowClass} from '../../../dbschema';

export class MTOComponentTieredPricingContainerModel extends BaseContainerModel {

  bl_fi_mto_component_tiered_pricing: bl_fi_mto_component_tiered_pricing_RowClass = new bl_fi_mto_component_tiered_pricing_RowClass();
}
